/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { ApplicationPath } from '../services/shared/shared-enums';
@Injectable({ providedIn: 'root' })
export class TranslationGuard implements CanActivate 
{
	constructor(private translate: TranslateService, private router: Router) { }

	canActivate(route: ActivatedRouteSnapshot): Observable<boolean>
	{
		const languages = [ 'en', 'fr' ];
		if(!languages.includes(route.params['lang']))
		{
			this.router.navigate([this.translate.currentLang + ApplicationPath.unAuthError]);
			return of(false); 
		}
		return of(true);
	}
}
